<template>
  <div class="cart-wrap ptb-100">
    <div class="container">
      <div class="cart-table">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Product
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Price
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Quantity
              </th>
              <th scope="col" class="text_secondary fs-20 f-secondary">
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="product-item">
                  <button class="cart-action" type="button">
                    <img src="../../assets/img/icons/close.svg" alt="Image" />
                  </button>
                  <div
                    class="product-img d-flex flex-column align-items-center justify-content-center"
                  >
                    <img
                      src="../../assets/img/shop/product-thumb-1.webp"
                      alt="Image"
                    />
                  </div>
                  <router-link
                    class="cart-item f-secondary text_secondary"
                    to="/product-details"
                  >
                    <span>Cat Fish Food</span>
                  </router-link>
                </div>
              </td>
              <td class="text_secondary">$59.00</td>
              <td>
                <QuantityCounter />
              </td>
              <td>$59.00</td>
            </tr>
            <tr>
              <td>
                <div class="product-item">
                  <button class="cart-action" type="button">
                    <img src="../../assets/img/icons/close.svg" alt="Image" />
                  </button>
                  <div
                    class="product-img d-flex flex-column align-items-center justify-content-center"
                  >
                    <img
                      src="../../assets/img/shop/product-thumb-2.webp"
                      alt="Image"
                    />
                  </div>
                  <router-link
                    class="cart-item f-secondary text_secondary"
                    to="/product-details"
                  >
                    <span>Can Food</span>
                  </router-link>
                </div>
              </td>
              <td class="text_secondary">$56.00</td>
              <td>
                <QuantityCounter />
              </td>
              <td>$56.00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row pb-45">
        <div class="col-xl-5 col-lg-7 col-md-7 col-sm-8 mb-25">
          <div class="coupon-code">
            <input type="text" placeholder="Coupon Code" />
            <button type="button" class="btn style-one">Apply Coupon</button>
          </div>
        </div>
        <div class="col-xl-7 col-lg-5 col-md-5 col-sm-4 text-sm-end mb-25">
          <button class="btn style-four update-cart" type="button">
            Update Cart
          </button>
        </div>
      </div>
      <div class="row pt-100">
        <div class="col-lg-5 offset-lg-7 col-md-8 offset-md-4">
          <div class="cart-total style-two">
            <h2 class="section-title">Cart Total</h2>
            <div class="cart-total-wrap">
              <div class="cart-total-item">
                <h6>Subtotal</h6>
                <h6>$170.97</h6>
              </div>
              <div class="cart-total-item">
                <h6>Shipping</h6>
                <div class="select-payment-method mt-20 text-end">
                  <div>
                    <input type="radio" id="test1" name="radio-group" />
                    <label for="test1">Free Shipping</label>
                  </div>
                  <div>
                    <input type="radio" id="test3" name="radio-group" />
                    <label for="test3">Flat Rate</label>
                  </div>
                  <div>
                    <input type="radio" id="test2" name="radio-group" />
                    <label for="test2">Local Pickup</label>
                  </div>
                </div>
              </div>
              <div class="cart-total-item">
                <h6>Total</h6>
                <h6>$170.97</h6>
              </div>
            </div>
          </div>
          <router-link class="btn style-one update-cart" to="/checkout">
            Proceed To Checkout
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QuantityCounter from "./QuantityCounter.vue";

export default defineComponent({
  name: "CartContent",
  components: {
    QuantityCounter,
  },
});
</script>